import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DirtyDialogComponent } from 'src/app/core/components/dirty-dialog.component';
import { SessionGroupEventModel } from 'src/app/core/services/api-services';
import { EventService, LanguageService as ApiLanguageService } from 'src/app/core/services/api-services';
import { MessageService } from 'src/app/core/services/message.service';

@Component({
    selector: 'app-guide-capacity',
    templateUrl: './guide-capacity.component.html',
    styleUrls: ['./guide-capacity.component.scss'],
    standalone: false
})
export class GuideCapacityDialogComponent extends DirtyDialogComponent implements OnInit {

  gridKey = 'pdSessionEventGuidesGridTable';

  displayedColumns: string[] = ['date', 'start', 'end', 'prename', 'surname', 'grouptype', 'size', 'language', 'gdAStartTime'];

  guideName: string;
  sessionGroupId: string;
  startTime: Date;
  dataSource: SessionGroupEventModel[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) data: any,
    protected override readonly messageService: MessageService,
    protected override readonly matDialogRef: MatDialogRef<GuideCapacityDialogComponent>,
    private readonly eventsService: EventService,
    private readonly languageService: ApiLanguageService) {
    super(messageService, matDialogRef);

    this.guideName = data.guideName;
    this.sessionGroupId = data.sessionGroupId;
    this.startTime = data.startTime;
    this.dataSource = data.dataSource;
  }

  onOpenCalendar(): void {
    let startDate = new Date(this.startTime);
    window.open('/private/guide/calendar?date=' + startDate.toISOString().slice(0,10), '_blank');
  }
}
